import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
// Ionic native- providers
//Components- declarations, entry components
//Pages- declarations, entry components
import { SignInPage } from './sign-in/sign-in';
import { RegisterPage } from './register/register';
import { PasswordPage } from './password/password';
import { PolicyPage } from './policy/policy';
//Services- providers 

@NgModule({
    declarations: [
        SignInPage,
        RegisterPage,
        PasswordPage,
        PolicyPage
    ],
    imports: [
        IonicModule.forRoot(SignInPage)
    ],
    entryComponents: [
        SignInPage,
        RegisterPage,
        PasswordPage,
        PolicyPage
    ],
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/pages/auth/auth.module.ts